
import {createAsyncThunk} from '@reduxjs/toolkit'
import { fetchAppSettings } from 'sr/utils/api/admin/app-settings/fetchAppSettings'
export const getAppSettings = createAsyncThunk(
  'appSettings',
  async () => {
    const response = await fetchAppSettings()
    return response?.data
  }
)


